import React, { FC } from "react"
import { FiCalendar } from "react-icons/fi"
import { AiOutlineClockCircle } from "react-icons/ai"

import { priceFormatter } from "@lib/functions"
import { Risebinar } from "@interfaces/risebinar"

import clsx from "clsx"
import { ImageCover } from "../misc/Image"
import { BasicLink } from "../typography"
import { FlexBox } from "@components/wrapper"

export interface RisebinarCardProps {
  data: Risebinar
  index: number
}

export const RisebinarCard: FC<RisebinarCardProps> = ({ data, index }) => {
  return (
    <BasicLink href={`/${data?.risebinar_slug}`}>
      <div className="w-full rounded-[4px] border-[1px] border-[#dfe0e1] hover:shadow-2xl">
        <ImageCover
          src={data?.risebinar_asset?.asset_path}
          alt={data?.risebinar_slug}
          size={[400, 250]}
          rounded="rounded-t-[4px]"
        />

        <div className={clsx("text-black-48 bg-primary-grey sm:p-4 p-3")}>
          <div className={clsx("mb-2 text-blue responsive-font")}>
            {data?.risebinar_category.category_name}
          </div>
          <h3
            id={`risebinar-title-${index}`}
            className={clsx("text-black-48 font-medium line-clamp-2 h-[3em] responsive-font")}
          >
            {data?.risebinar_title}
          </h3>

          <hr className="text-[#dfe0e1] my-4" />

          <FlexBox className={clsx("gap-4 responsive-font mb-2")} align="center">
            <FiCalendar className="text-green" />
            <span>{data?.risebinar_date}</span>
          </FlexBox>

          <FlexBox className={clsx("gap-4 responsive-font mb-2")} align="center">
            <AiOutlineClockCircle className="text-green" />
            <span>{data?.risebinar_time}</span>
          </FlexBox>

          <div className="flex justify-between items-center">
            <div className={clsx("leading-[20px] responsive-font")}>Mulai dari</div>
            <div className={clsx("font-semibold sm:text-md text-green")}>
              {priceFormatter(data?.risebinar_program?.program_price)}
            </div>
          </div>
        </div>
      </div>
    </BasicLink>
  )
}
